// extracted by mini-css-extract-plugin
export default {"textSeoMappingTitle":"Ajzwh","itineraryItem":"MLAAe","itineraryItemLink":"wqZuo"};